import axios from 'axios';
import config from './config';
import { getUserInfo } from './user';

export async function login(email, password) {
  const version = import.meta.env.VITE_APP_VERSION || 'dev';
  const deviceName = `Agromate Frontend ${version}`;
  const response = await axios.post(`${config.apiBaseUrl}/login`, {
    email,
    password,
    device_name: deviceName,
  });
  setToken(response.data.access_token);
  // Store token_id if present
  if (response.data.token_id) {
    localStorage.setItem('token_id', String(response.data.token_id));
  }
  // AuthController::login's response carries no user object (only access_token/token_id/
  // token_type/roles) - /me is the only source of the current user's id. Previously this was
  // fetched fire-and-forget, and only inside a now-always-false `if (response.data.data)`
  // check, so it never ran at all: sessionStorage['userInfo'] (and therefore
  // getCurrentUserId(), used by e.g. the dashboard's "mine" filter/badge) depended entirely
  // on Layout.jsx's own fetch-on-mount racing against whatever rendered first. Awaited here
  // instead, so it's reliably populated before the caller (Login.jsx) navigates anywhere.
  // getUserInfo() never throws - it catches its own errors and resolves null - so a failed
  // fetch here degrades to "id unknown yet", not a broken login.
  await getUserInfo(true);
}

export function logout() {
  setToken('');
}

export function getToken() {
  return localStorage.getItem('token');
}

export function setToken(token) {
  if (token) {
    localStorage.setItem('token', token);
  } else {
    localStorage.removeItem('token');
  }
}

export function isAuthenticated() {
  return !!getToken();
}
